export default {
	computed: {
		windowWidth() {
			return window.innerWidth;
		}
	}
}
